export default __webpack_public_path__ + "static/media/sam_komrower.c7be577a.png";